import { render, staticRenderFns } from "./AddTeam.vue?vue&type=template&id=747e47f8&"
import script from "./AddTeam.vue?vue&type=script&lang=ts&"
export * from "./AddTeam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports